
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";

export function WinningSymbolsCommand(symbols: SymbolComponent[], result: SymbolWinResult, cycling: boolean = false): Contract<void> {
    const winningSymbolWinMethods: Array<() => Contract<void>> = [];

    for (const symbol of symbols) {
        winningSymbolWinMethods.push(() => cycling ? symbol.cycle(result) : symbol.win(result));
    }

    return new Contract<void>((resolve) => {
        new Parallel(winningSymbolWinMethods).then(() => {
            resolve(null);
        });
    });
}
